var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{style:({ width: _vm.size, height: _vm.size }),attrs:{"src":require('' + _vm.icon),"fit":"fill"}})
}
var staticRenderFns = []

export { render, staticRenderFns }